export const createValidationMessage = (message, messageId) => ({
    message,
    messageId,
})



// WEBPACK FOOTER //
// ./src/modules/validation/create-validation-message.js